var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.videoTitle))]),_c('div',{staticClass:"view-num"},[_vm._v("播放次数："+_vm._s(_vm.viewNum))]),_c('div',{staticClass:"time"},[_vm._v("发布时间："+_vm._s(_vm.time.replace(/-/g, '/').slice(0, 16)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }